import {supportedLanguages} from './supported-languages';

export const environment = {
  production: true,
  basePath: 'pwa',
  supportedLanguages
};
